import React from 'react'
import Page from 'organization/Event/TemplateEditor/Page'
import Login from 'Event/auth/Login'
import {DesignBreadcrumbs} from 'organization/Event/Page/PageBreadcrumbs'
import LanguageSelector from 'organization/Event/LocalizationConfig/LanguageSelector'

export default function LoginConfig() {
  return (
    <DesignBreadcrumbs page="Login">
      <Page
        toolbarItems={
          <>
            <LanguageSelector />
          </>
        }
      >
        <Login isPreview />
      </Page>
    </DesignBreadcrumbs>
  )
}
